import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4d054ecf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-12 col-md-12 col-12" }

import PageHead from '@/components/shared/PageHead.vue';
import ProxyChecker from '@/components/freebies/checker/ProxyChecker.vue';
import CheckerOutput from '@/components/freebies/checker/CheckerOutput.vue';
import BlogSection from '@/components/shared/BlogSection.vue';
import { state } from '@/composables/proxy-checker';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const head = {
  title: 'Online proxy checker',
  subtitle: 'Put your proxies in the textbox and start checking your proxies!',
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(PageHead, { head: head }),
        _createElementVNode("div", _hoisted_3, [
          _withDirectives(_createVNode(ProxyChecker, null, null, 512), [
            [_vShow, _unref(state).showChecker]
          ]),
          (_unref(state).showOutput && !_unref(state).error)
            ? (_openBlock(), _createBlock(CheckerOutput, {
                key: 0,
                total: _unref(state).total_proxies,
                wProxies: _unref(state).working_proxies,
                dProxies: _unref(state).dead_proxies,
                proxies: _unref(state).response
              }, null, 8, ["total", "wProxies", "dProxies", "proxies"]))
            : _createCommentVNode("", true)
        ]),
        _createVNode(BlogSection)
      ])
    ])
  ]))
}
}

})